require("./common/init").init();
require("./proxy-vote/init").init();